import { createSlice } from '@reduxjs/toolkit';

const runtimeHistorySlice = createSlice({
  name: 'runtimeHistory',
  initialState: {
    entity: {
      inferenceDetails: [],
      count: 0,
    },
  },
  reducers: {
    storeInferences: (state, action) => {
      state.entity = action.payload;
    },
  },
});

const {
  reducer: runtimeHistoryReducer,
  actions: { storeInferences },
} = runtimeHistorySlice;

export { runtimeHistoryReducer, storeInferences };
